import { render, staticRenderFns } from "./CardSimpleStyle.vue?vue&type=template&id=4f4142d4&"
import script from "./CardSimpleStyle.vue?vue&type=script&lang=js&"
export * from "./CardSimpleStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\vsProject\\dsf-product-exam\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f4142d4')) {
      api.createRecord('4f4142d4', component.options)
    } else {
      api.reload('4f4142d4', component.options)
    }
    module.hot.accept("./CardSimpleStyle.vue?vue&type=template&id=4f4142d4&", function () {
      api.rerender('4f4142d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/components/CardSimpleStyle.vue"
export default component.exports